import React from 'react';
import useParticleCanvas from '../../hooks/useParticleCanvas';

export default function ParticleCanvas() {
  const canvasRef = useParticleCanvas();

  return (
    <div className="lp-hero-canvas" aria-hidden="true">
      <canvas ref={canvasRef} />
    </div>
  );
}
